import { ASSETS_LOCATIONS, getAssetsUrl } from '../../../utilities/constants';

export const OFFERS_IMAGES = {
  OFFERS_GWL_VOYAGERS_CLUB: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'gwl-voyagers-club.svg'),
  OFFERS_GWL_VOYAGERS_CLUB_2: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'VoyagerClub-Moonlight.svg'),
  OFFERS_V_GREEN_ICON: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'v-green.svg'),
  OFFERS_V_BLUE_ICON: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'v-blue.svg'),
  OFFERS_V_GRAY_ICON: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'v-gray.svg'),
  VOYAGERS_DEALS_ICON: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'voyagers-dollar-icon.svg'),
  VOYAGER_ICON_FOREST_GREEN: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'VoyagersIcon-forest-green.svg'),
  VOYAGERS_ICON_MOSS: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'voyagers-icon-moss.svg')
};
